import { useDynamicParam } from '@Alias/hooks';
import { DynamicPath } from '../../constants/router';

export function useDeviceActivationCode() {
  return useDynamicParam(DynamicPath.ACTIVATE, 'activationCode');
}
